import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, UrlTree} from '@angular/router';
import {AuthService} from './auth.service';

/**
 * Allows Super Users onto Organization child tabs (Operational Readiness,
 * Customer Integrations, EEN Account). Non–Super Users are sent to Profile.
 */
@Injectable({
    providedIn: 'root',
})
export class OrganizationSuperUserTabGuard implements CanActivate {
    constructor(
        private auth: AuthService,
        private router: Router,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        if (!this.auth.isAuthenticated()) {
            return this.router.createUrlTree(['/login']);
        }
        if (this.auth.isSuperUser()) {
            return true;
        }
        const organizationId =
            route.parent?.paramMap.get('organizationId')
            || route.paramMap.get('organizationId')
            || route.parent?.paramMap.get('pk')
            || route.paramMap.get('pk');
        if (organizationId) {
            return this.router.createUrlTree(
                ['/organization', organizationId, 'profile'],
                {
                    queryParams: route.queryParams,
                    fragment: route.fragment || undefined,
                },
            );
        }
        return this.router.createUrlTree(['/organization'], {
            queryParams: route.queryParams,
            fragment: route.fragment || undefined,
        });
    }
}
